import { render, staticRenderFns } from "./QuestionCity.vue?vue&type=template&id=01ac6cbe&scoped=true&"
import script from "./QuestionCity.vue?vue&type=script&lang=js&"
export * from "./QuestionCity.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCity.vue?vue&type=style&index=0&id=01ac6cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac6cbe",
  null
  
)

export default component.exports